function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;


//////////////////
// WEBPACK FOOTER
// /home/caligram/admin.caligram.com/shared/~/react-bootstrap/~/@babel/runtime-corejs2/helpers/interopRequireDefault.js
// module id = 4
// module chunks = 0